// Admin API client — /admin/tickets/* (mirrors the API's tickets aggregate).

import type { AdminSupportTicket } from '@a7y/types';
import { client, PaginatedResponse } from './transport';

export const ticketsApi = {
  // Support
  getTickets: (params?: { page?: number; limit?: number; status?: string }) =>
    client.get<PaginatedResponse<AdminSupportTicket>>(
      `/tickets?${new URLSearchParams(params as Record<string, string>)}`
    ),
  getTicket: (id: string) => client.get<AdminSupportTicket>(`/tickets/${id}`),
  replyToTicket: (id: string, data: { message: string; isInternal: boolean }) =>
    client.post<{ message: string; ticketId: string }>(`/tickets/${id}/reply`, data),
};
